import { ACTIONS_LOGIN } from '../actions/actionTypes';

const initialState = {
    login: {active: false}
};

export const reducersLogin = (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS_LOGIN:
            return {
                ...state,
                login: action.login
            };
        default:
            return state;
    }
};